export default "__VITE_ASSET__0caedfbc__"